<template>
    <agentRegister :value="registerInfo" :visible.sync="dialogFormVisible" v-if="dialogFormVisible" @success="registerSuccess" :error-msg="errorMsg" :isInstitution="true"></agentRegister>
</template>

<script>
import agentRegister from '@/views/login/agentRegister'
export default {
  name: 'newInstitution',
  components: {
    agentRegister
  },
  data () {
    return {
      registerInfo: {},
      dialogFormVisible: true,
      errirMsg: '',
      agentQualification: 2 // 代理商资质，0：携机顶代；1：大区；2：机构；3：代理商；4：服务商。携机和收付贝必填
    }
  },
  methods: {
    registerSuccess () {
      this.$router.push('/Partner/Institution/institutionList')
    }
  }
}
</script>

<style>

</style>
